import { render, staticRenderFns } from "./PoliUser.vue?vue&type=template&id=aa15a1c8"
import script from "./PoliUser.vue?vue&type=script&lang=js"
export * from "./PoliUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports